import React from 'react'
import Footer from '../../Back/pages/components/Footer'
import Header from '../Header'
// import Header from '../../Back/pages/components/Header'

function FAQ() {
  const data = require('./FAQ.json')
  return (
    <>
    <Header />
    <div className='container card p-2 px-4' style={{marginBottom:"8rem"}}>
      {
        data.map((e, i) => {
          return (
            <div className='my-2' key={i}>
              <h3>{e.title}</h3>
              {e.description.split('\n').map((str, j) =>
                str.trim() ? (
                  <p key={j}>
                    {str.includes('chloe@notenest.com') ? (
                      <>
                        {str.split('chloe@notenest.com')[0]}
                        <a href='mailto:chloe@notenest.com'>chloe@notenest.com</a>
                        {str.split('chloe@notenest.com')[1]}
                      </>
                    ) : (
                      str
                    )}
                  </p>
                ) : null
              )}
            </div>
          );
        })
      }
    </div>
    <Footer />
    </>
  )
}

export default FAQ